module.exports = __webpack_public_path__ + "img/copy.377c58e6.svg";